import { useState } from "react"

export type ToggleModel = { isOpen: boolean, open: () => void, close: () => void, set: (val: boolean) => void, isUndefined: boolean }
export const useToggle = (initial: boolean | undefined): ToggleModel => {
    const [ val, set ] = useState(initial)
    const open = () => set(true)
    const close = () => set(false)
    return { isOpen: !!val, open, close, set, isUndefined: val === undefined }
}